import { Reducer } from "redux";

import { ClicksAction, ClicksActionTypes, ClicksState } from "./types";

const initialState: ClicksState = {
  count: 0,
  tableData: [],
  isLoading: false,
  retrieveIsLoading: false,
};

const reducer: Reducer<ClicksState, ClicksAction> = (state = initialState, action) => {
  switch (action.type) {
    case ClicksActionTypes.TABLE_FETCH_REQUEST:
      return { ...state, isLoading: true };

    case ClicksActionTypes.TABLE_FETCH_ERROR:
      return { ...state, isLoading: false };

    case ClicksActionTypes.TABLE_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, isLoading: false, tableData: results };
    }

    case ClicksActionTypes.RETRIEVE_FETCH_REQUEST:
      return { ...state, retrieveIsLoading: true, retrieve: undefined };

    case ClicksActionTypes.RETRIEVE_FETCH_SUCCESS:
      return { ...state, retrieve: action.payload, retrieveIsLoading: false };

    case ClicksActionTypes.RETRIEVE_FETCH_ERROR:
      return { ...state, retrieveIsLoading: false };

    default:
      return state;
  }
};

export default reducer;
